module.exports = __webpack_public_path__ + "img/device-blue.2cfc4c12.svg";